import { render, staticRenderFns } from "./AcoesDeclaracoes.vue?vue&type=template&id=2406271a&scoped=true"
import script from "./AcoesDeclaracoes.vue?vue&type=script&lang=js"
export * from "./AcoesDeclaracoes.vue?vue&type=script&lang=js"
import style0 from "./AcoesDeclaracoes.vue?vue&type=style&index=0&id=2406271a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406271a",
  null
  
)

export default component.exports